import React, { useMemo } from 'react';
import AspectRatioBox from '@components/shared/AspectRatioBox/AspectRatioBox';
import { getResizedImageUrl } from '@lib/image';
import classNames from 'classnames';
import styles from './AvatarImage.module.scss';
import Image from '../Image/Image';

interface IAvatarImageProps {
  alt: string;
  imageUrl: string;
  width?: number;
  height?: number;
  aspectRatio?: number;
  square?: boolean;
}

const AvatarImage = ({
  alt,
  imageUrl,
  width = 133,
  height = 133,
  aspectRatio = 1,
  square = false
}: IAvatarImageProps) => {
  const imageUrls = useMemo(() => {
    return {
      default: getResizedImageUrl({
        url: imageUrl || '',
        height: height * aspectRatio,
        width,
        quality: 100,
      }),
    };
  }, [imageUrl]);

  return (
    <AspectRatioBox aspectRatio={aspectRatio}>
      {imageUrl ? (
        <Image
          alt={alt}
          width={width}
          height={height}
          className={classNames(
            styles.avatar,
            { [styles.square]: square }
          )}
          src={imageUrls.default}
        />
      ) : (
        <div className={styles.NoImageSrc} />
      )}
    </AspectRatioBox>
  );
};

export default AvatarImage;
